import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from '../layout/auth-layout/auth-layout.component';
import { LoginComponent } from './login/login.component';
import { McfMobileLoginComponent } from './mcf-mobile-login/mcf-mobile-login.component';
import { TimeOutComponent } from './login/time-out.component';

const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      { path: 'login/mobile', component: McfMobileLoginComponent },
      { path: 'login', component: LoginComponent },
      { path: 'session-time-out', component: TimeOutComponent },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
